
import 'firebase/compat/auth'; // removed in build process when not UMD

export * from './auth';
export * from './auth.module';
